import { useEffect, useMemo } from 'react'
import { createFFmpeg, FFmpeg } from '@ffmpeg/ffmpeg'

export function useFfmpeg(): FFmpeg {
  const ffmpeg = useMemo(() => createFFmpeg(), [])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return () => {
        if (ffmpeg.isLoaded()) {
          ffmpeg.exit()
        }
      }
    }
  }, [ffmpeg])

  return ffmpeg
}
